<script lang="ts">
	interface Props {
		className?: string;
		status?: Status;
		disabled?: boolean;
	}

	let { className = '', status = $bindable('unknown'), disabled = false }: Props = $props();

	type Status = 'unknown' | 'checked' | 'question' | 'cross';

	function toggle() {
		if (disabled) {
			return;
		}
		if (status === 'checked') {
			status = 'cross';
		} else if (status === 'question') {
			status = 'checked';
		} else if (status === 'cross') {
			status = 'unknown';
		} else {
			status = 'question';
		}
	}

	function getColor(status: Status) {
		if (status === 'checked') {
			return 'text-success';
		} else if (status === 'question') {
			return 'text-warning';
		} else if (status === 'cross') {
			return 'text-error';
		} else {
			return 'text-disabled-on';
		}
	}

	let color = $derived(getColor(status));
</script>

<button
	{disabled}
	class="{className} {color}"
	onclickcapture={(e) => {
		e.stopPropagation();
		toggle();
	}}
	aria-label="Toggle"
>
	<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="transition-all">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22Z

        {status == 'checked'
				? 'M16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z'
				: ''}

        {status == 'question' || status == 'unknown'
				? 'M12 7.75C11.3787 7.75 10.875 8.25368 10.875 8.875C10.875 9.28921 10.5392 9.625 10.125 9.625C9.71079 9.625 9.375 9.28921 9.375 8.875C9.375 7.42525 10.5503 6.25 12 6.25C13.4497 6.25 14.625 7.42525 14.625 8.875C14.625 9.58584 14.3415 10.232 13.883 10.704C13.7907 10.7989 13.7027 10.8869 13.6187 10.9708C13.4029 11.1864 13.2138 11.3753 13.0479 11.5885C12.8289 11.8699 12.75 12.0768 12.75 12.25V13C12.75 13.4142 12.4142 13.75 12 13.75C11.5858 13.75 11.25 13.4142 11.25 13V12.25C11.25 11.5948 11.555 11.0644 11.8642 10.6672C12.0929 10.3733 12.3804 10.0863 12.6138 9.85346C12.6842 9.78321 12.7496 9.71789 12.807 9.65877C13.0046 9.45543 13.125 9.18004 13.125 8.875C13.125 8.25368 12.6213 7.75 12 7.75M12 17C12.5523 17 13 16.5523 13 16C13 15.4477 12.5523 15 12 15C11.4477 15 11 15.4477 11 16C11 16.5523 11.4477 17 12 17Z'
				: ''}

        {status == 'cross'
				? 'M8.8183 8.81803C9.1112 8.52513 9.58607 8.52513 9.87896 8.81803L12.0003 10.9394L14.1216 8.81803C14.4145 8.52513 14.8894 8.52513 15.1823 8.81803C15.4752 9.11092 15.4752 9.5858 15.1823 9.87869L13.0609 12L15.1823 14.1213C15.4752 14.4142 15.4752 14.8891 15.1823 15.182C14.8894 15.4749 14.4145 15.4749 14.1216 15.182L12.0003 13.0607L9.87897 15.182C9.58608 15.4749 9.1112 15.4749 8.81831 15.182C8.52542 14.8891 8.52542 14.4142 8.81831 14.1213L10.9396 12L8.8183 9.87869C8.52541 9.58579 8.52541 9.11092 8.8183 8.81803Z'
				: ''}

        "
			fill="currentColor"
		></path>
	</svg>
</button>
